import React from 'react';
import { Skeleton } from '@tcc/crate';
import { getMessage } from 'util/locale';
import propTypes from 'prop-types';
import { convertForLocale } from 'util/unitConversion';
import { scriptMethods } from 'constants/scripts';
const baseString = 'vra-field-info';

const FieldInfo = ({
  activeFarm,
  activeField,
  activeScriptMethod,
  activeScriptType,
  areaFromZones,
  isVisible=true,
  showManualSelectedDate = {
    isManualV2: false,
    manualSelectedDate: ''
  },
  showOwnerName=false,
  showScriptFlow=false,
  isFetched=false,
}) => {
  if (isVisible && !isFetched) {
    return <section className={baseString}><Skeleton height={16} width={150} /></section>;
  }

  if (!activeField || !isVisible) {
    return null;
  }
  const isAdvanced = activeScriptMethod === scriptMethods.ADVANCED;
  const { name, area: areaFromHomestead } = activeField;
  const { growerName: ownerName } = activeFarm;
  const area = areaFromZones.q ? areaFromZones : areaFromHomestead;
  const convertedArea = convertForLocale({quantity: area.q, unit: area.u, unitType: 'area'}).toString();

  let contentKey = 'title-text__field-info';
  let contentProps = { name: name, area: convertedArea };

  if (showOwnerName || showScriptFlow) {
    contentKey = 'title-text__field-info--with-text';

    if (showOwnerName) {
      contentProps.text = ownerName;
    } else {
      contentProps.text = isAdvanced
        ? getMessage('text__fieldview-seed-scripts')
        : getMessage(`title-text__${activeScriptMethod}-${activeScriptType}-script`);
    }
  }

  return (
    <section>
      <section className={baseString}>
        {getMessage(contentKey, contentProps)}
      </section>
      { showManualSelectedDate.isManualV2
        ? <section className={baseString}>{showManualSelectedDate.manualSelectedDate}</section>
        : ''
      }
    </section>
  );
};

FieldInfo.propTypes = {
  activeFarm: propTypes.object.isRequired,
  activeField: propTypes.object.isRequired,
  activeScriptMethod: propTypes.string.isRequired,
  activeScriptType: propTypes.string.isRequired,
  areaFromZones: propTypes.object.isRequired,
  isVisible: propTypes.bool,
  showManualSelectedDate: propTypes.object,
  showOwnerName: propTypes.bool,
  showScriptFlow: propTypes.bool,
  isFetched: propTypes.bool
};

export default FieldInfo;
